import { Input, InputGroup, InputLeftElement, Text, Box } from '@chakra-ui/react';
import { NavLink, useNavigate } from 'react-router-dom';
import React from 'react';
import { SidebarOption, SidebarProps } from '../interfaces/components';
import SidebarItem from './SideBarItem';
import { SearchIcon } from '@chakra-ui/icons';

function Sidebar({ activeView, sidebarOptions, setActiveView }: SidebarProps) {
  const navigate = useNavigate();

  return (
    <>
      <Box
        w="66px"
        borderRight="1px solid rgba(0, 0, 0, 0.10)"
        background="#FFF"
        padding="12px"
        display={['none', 'none', 'flex', 'none']}
        flexDirection="column"
      >
        {activeView !== 'home' && (
          <Box cursor="pointer" onClick={() => navigate('/')}>
            <InputGroup cursor="pointer">
              <InputLeftElement pointerEvents="none">
                <SearchIcon />
              </InputLeftElement>
              <Input
                placeholder="Search for Crypto Projects"
                borderRadius="9px"
                border="none"
                background=" rgba(0, 0, 0, 0.05)"
                size="sm"
                height="34px"
                width="242px"
              />
            </InputGroup>
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap="10px" marginTop="36px">
          {sidebarOptions.map((sideBarOption: SidebarOption) => (
            <Box
              key={sideBarOption.key}
              width="46px"
              height="38px"
              borderRadius="12px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              background={activeView === sideBarOption.key ? '#5772FF' : '#E5E5E5'}
              color={activeView === sideBarOption.key ? 'white' : '#000'}
            >
              <NavLink to={sideBarOption.href}>
                <Box>{sideBarOption?.sideBarIcon}</Box>
              </NavLink>
            </Box>
          ))}
        </Box>
      </Box>
      <Box
        w="290px"
        borderRight="1px solid rgba(0, 0, 0, 0.10)"
        background="#FFF"
        padding="24px"
        display={['none', 'none', 'none', 'flex']}
        flexDirection="column"
        gap="36px"
      >
        {activeView !== 'home' && (
          <Box cursor="pointer" onClick={() => navigate('/')}>
            <InputGroup cursor="pointer">
              <InputLeftElement pointerEvents="none">
                <SearchIcon />
              </InputLeftElement>
              <Input
                placeholder="Search for Crypto Projects"
                borderRadius="9px"
                border="none"
                background=" rgba(0, 0, 0, 0.05)"
                size="sm"
                height="34px"
                width="242px"
              />
            </InputGroup>
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap="10px">
          {sidebarOptions.map((sideBarOption: SidebarOption) => (
            <Box key={sideBarOption.key}>
              <NavLink to={sideBarOption.href}>
                <SidebarItem
                  sideBarItemKey={sideBarOption.key}
                  sideBarIcon={sideBarOption.sideBarIcon}
                  text={sideBarOption.text}
                  active={activeView === sideBarOption.key}
                  setActiveView={() => setActiveView(sideBarOption.key)}
                />
              </NavLink>
            </Box>
          ))}
        </Box>

        <Box display="flex" justifyContent="center" marginTop="auto">
          <Text color="rgba(0, 0, 0, 0.50)" fontSize="12px" fontStyle=" normal" fontWeight=" 500" lineHeight="normal">
            © 2026 Covey, all rights reserved
          </Text>
        </Box>
      </Box>
    </>
  );
}

export default Sidebar;
